import {
  Box,
  Typography,
  Tooltip,
  IconButton,
  MenuItem,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Autocomplete,
} from '@mui/material';
import { FilterListOff } from '@mui/icons-material';


const FilterDialog = ({ 
  open, 
  onClose, 
  onChange, 
  onClear, 
  filters, 
  airportCodes, 
  acTypes, 
}) => {
  const { dep, arr, acType, carrier } = filters;
  const activeCount = [dep, arr, acType, carrier].filter(Boolean).length;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ pb: 0.5 }}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6">Filter</Typography>
          {activeCount > 0 && (
            <Tooltip title="Clear all filters">
              <IconButton size="small" onClick={onClear}>
                <FilterListOff fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </DialogTitle>

      <DialogContent dividers>
        <Box display="flex" flexDirection="column" gap={2}>
          <Box display="flex" gap={1}>
            {[
              { label: 'DEP', value: dep, field: 'dep' },
              { label: 'ARR', value: arr, field: 'arr' },
            ].map(({ label, value, field }) => (
              <Autocomplete
                key={field}
                freeSolo
                size="small"
                options={airportCodes}
                value={value || null}
                inputValue={value}
                onChange={(_, v) => onChange(field, (v || '').toUpperCase().slice(0, 3))}
                onInputChange={(_, v, reason) => { if (reason !== 'reset') onChange(field, v.toUpperCase().slice(0, 3)); }}
                renderInput={(params) => <TextField {...params} label={label} size="small" fullWidth />}
                sx={{ flex: 1 }}
              />
            ))}
          </Box>
          
          <Box display="flex" gap={1}>
            <TextField
              select 
              fullWidth 
              size="small" 
              label="AC Type"
              value={acType}
              onChange={(e) => onChange('acType', e.target.value)}
              sx={{ flex: 1 }}
            >
              <MenuItem value="">All</MenuItem>
              {acTypes.map((t) => (
                <MenuItem key={t._id} value={t.acTypeCode}>
                  {t.acTypeCode}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              fullWidth 
              size="small" 
              label="Carrier"
              value={carrier}
              onChange={(e) => onChange('carrier', e.target.value.toUpperCase())}
              slotProps={{ htmlInput: { maxLength: 3 } }}
              sx={{ flex: 1 }}
            />
          </Box>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button 
          onClick={onClear} 
          disabled={activeCount === 0}
        >
          Clear All
        </Button>
        <Button 
          variant="outlined" 
          color="secondary"
          onClick={onClose}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FilterDialog;
